// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__3a6dr"};